import { useEffect, useContext, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./Css/Card.css";
import "./Css/CategoryWrapper.css";
import { AppContext } from "../../context/AppContext";
import MetaTag from "./MetaTag";

// You can replace these with your real ad components
import AdvertisementLeft from "./AdvertisementLeft";
import AdvertisementRight from "./AdvertisementRight";

const MenuWrapper = () => {
  const { categoryName } = useParams();
  const [cardsData, setCardsData] = useState([]);
  const navigate = useNavigate();

  const {
    baseUrl,
    gameUrl,
    Backend_folder_path,
    addGameUrl,
    setCategory,
    gameList,
    setgamelist,
    setdescreption,
    setPageRefreshCount,
    metaTag,
    setgametitle,
    setmetadata,
    setgametype,
    setgameid,
    setappstorelink,
    AppStoreLink,
    addThumbImg,
  } = useContext(AppContext);

  const [meta, setMeta] = useState({
    title: "",
    keywords: "",
    descreption: "",
  });

  useEffect(() => {
    const newCards = gameList.map((game, index) => ({
      title: `${game.game_title}`,
      id: index + 1,
      path: `${Backend_folder_path}${game.folder_path}/index.html`,
      thumb_img: `${Backend_folder_path}${game.thumbnail_img_path}`,
      url: game.url,
      category: game.category,
      descreption: game.description,
      enable: game.enable,
      meta_title: game.meta_title,
      meta_keyword: game.meta_keyword,
      meta_description: game.meta_description,
      gameType: game.gameType,
      gameId: game.id,
      iso_link: game.iso_link,
      playstore_link: game.playstore_link,
    }));
    setCardsData(newCards);
  }, [gameList]);

  const handleClick = (game) => {
    addGameUrl(game.path);
    addThumbImg(game.thumb_img);
    setCategory(game.category);
    setdescreption(game.descreption);
    setgametitle(game.title);
    setmetadata({
      title: game.meta_title,
      keywords: game.meta_keyword,
      descreption: game.meta_description,
    });
    setgametype(game.gameType);
    setgameid(game.gameId);
    setappstorelink({
      ...AppStoreLink,
      iso_link: game.iso_link,
      playstore_link: game.playstore_link,
    });

    const titleTag = document.querySelector("head > title");
    titleTag.textContent = game.meta_title;

    navigate(`/game/${game.url}`);
  };

  return (
    <>
      {meta.title && meta.keywords && (
        <MetaTag
          title={meta.title}
          keywords={meta.keywords}
          descreption={meta.descreption}
        />
      )}

      <div className="gallery-container">
        <h1 style={{ fontSize: "14px" }}>
          Free Online Games - <span>htmlgames4u.com</span>
        </h1>

        {/*  Three-column layout */}
        <div className="main-grid">
          {/* Left Advertisement */}
          <div className="left-ad">
            <AdvertisementLeft />
          </div>

          {/* Game Grid in the Center */}
          <div className="game-section">
            <div className="game-grid">
              {cardsData.map(
                (game) =>
                  game.enable && (
                    <div
                      style={{ cursor: "pointer" }}
                      className="game-card"
                      key={game.id}
                    >
                      <img
                        onClick={() => handleClick(game)}
                        src={game.thumb_img}
                        alt={game.title}
                      />
                      <div className="hover-title">{game.title}</div>
                    </div>
                  )
              )}
            </div>
          </div>

          {/* Right Advertisement */}
          <div className="right-ad">
            <AdvertisementRight />
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuWrapper;
